import React, { PureComponent } from "react";
import Chrome from "@zendesk/knowledge-chrome/lib/Chrome";
import t from "@zendesk/client-i18n-tools";
import { Sidebar, ContentView } from "@zendesk/guide-chrome";
import createBrandedUrl from "@zendesk/knowledge-utils/lib/createBrandedUrl";
import styles from "./styles.css";
import IndexPage from "./IndexPage";

import {
  getCurrentBrandId,
  hasFeature,
  getHelpCenter,
} from "@zendesk/knowledge-context";

import ErrorBoundary from "components/ErrorBoundary";

export default class IndexRoute extends PureComponent {
  render() {
    const subdomain = getHelpCenter().route.subdomain;

    return (
      <Chrome
        brandId={getCurrentBrandId()}
        dir={t.dir}
        topNav={
          <Chrome.Breadcrumbs>
            <Chrome.Breadcrumbs.Item key="settings">
              <a href="/hc/admin/general_settings">
                {t("knowledge-verification.settings")}
              </a>
            </Chrome.Breadcrumbs.Item>
            <Chrome.Breadcrumbs.Separator />
            <Chrome.Breadcrumbs.Item key="verification">
              {t("knowledge-verification.articleVerifications")}
            </Chrome.Breadcrumbs.Item>
          </Chrome.Breadcrumbs>
        }
      >
        <Sidebar>
          <Sidebar.LinkItem
            href={createBrandedUrl(subdomain, "/hc/admin/general_settings")}
            testId="sidebar-general-settings"
          >
            {t("knowledge-verification.hcGeneralSettings")}
          </Sidebar.LinkItem>
          <Sidebar.Item active testId="sidebar-article-verification">
            {t("knowledge-verification.articleVerifications")}
          </Sidebar.Item>
          {hasFeature("automatic_answers") && (
            <Sidebar.LinkItem
              href={createBrandedUrl(subdomain, "/hc/admin/answer_bot")}
              testId="sidebar-answer-bot-settings"
            >
              {t("knowledge-verification.hcAnswerBotSetting")}
            </Sidebar.LinkItem>
          )}
        </Sidebar>
        <ContentView>
          <ErrorBoundary>
            <div className={styles.content}>
              <IndexPage />
            </div>
          </ErrorBoundary>
        </ContentView>
      </Chrome>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndexRoute/index.js